module.exports = __webpack_public_path__ + "img/digital_Ind.2a981189.jpg";